import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TCreateDiscountSettingsAPIParams,
    TDiscountDetailsSettings,
    TGetDiscountSettingsAPIParams,
    TGetDiscountSettingsAPIResponse,
} from '~types/feat/setting';

export abstract class IDiscountGateway extends Gateway {
    abstract getDiscountsSettings(params: TGetDiscountSettingsAPIParams): GatewayResponse<TGetDiscountSettingsAPIResponse>;

    abstract getDiscountsFilterSettings(params: ProtectedRoute): GatewayResponse<TDiscountDetailsSettings[]>;

    abstract createDiscountsSettings(params: TCreateDiscountSettingsAPIParams): GatewayResponse<string | null>;

    abstract updateDiscountsSettings(params: TCreateDiscountSettingsAPIParams): GatewayResponse<string | null>;
}
